// User-facing names for substatus codes that must not be derived by
// sentence-casing the code (TECH-12310 FR1: the held-order substatus
// displays as "PenChecks").
const substatusDisplayNameOverrides = {
  pendingInternalVerification: "PenChecks",
};

export default substatusDisplayNameOverrides;
